import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { EmissionCategory, CATEGORY_COLORS, CATEGORY_DISPLAY_NAMES } from '../../lib/emission-categories';

interface CategoryEmissionData {
  category: EmissionCategory;
  value: number;
  percentage: number;
}

interface EmissionsByCategoryDonutProps {
  data: CategoryEmissionData[];
  selectedYear?: number;
}

export function EmissionsByCategoryDonut({ data, selectedYear = new Date().getFullYear() }: EmissionsByCategoryDonutProps) {
  // Custom tooltip component
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload as CategoryEmissionData;
      const category: EmissionCategory = data.category;
      return (
        <div className="bg-white p-3 border border-green-200 rounded-lg shadow-lg">
          <p className="font-semibold text-green-800">
            {CATEGORY_DISPLAY_NAMES[category]}
          </p>
          <p className="text-sm text-green-600">
            {data.value.toFixed(2)} MTCO2e
          </p>
          <p className="text-sm text-green-500">
            {data.percentage.toFixed(1)}%
          </p>
        </div>
      );
    }
    return null;
  };

  // Custom legend component
  const CustomLegend = ({ payload }: any) => {
    return (
      <div className="flex flex-col space-y-2 mt-4">
        {payload.map((entry: any, index: number) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div 
                className="w-3 h-3 rounded-full" 
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-green-700 font-medium">
                {entry.value}
              </span>
            </div>
            <span className="text-sm text-green-600 font-medium">
              {entry.payload.percentage.toFixed(1)}%
            </span>
          </div>
        ))}
      </div>
    );
  };

  // Calculate total for percentage calculations
  const total = data.reduce((sum, item) => sum + item.value, 0);

  // Add percentage to each data item
  const dataWithPercentage = data.map(item => ({
    ...item,
    percentage: total > 0 ? (item.value / total) * 100 : 0
  }));

  return (
    <div className="w-full h-80">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={dataWithPercentage}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
            stroke="white"
            strokeWidth={2}
          >
            {dataWithPercentage.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={CATEGORY_COLORS[entry.category]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend content={<CustomLegend />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}













